import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Flex, View } from "@amzn/stencil-react-components/layout";
import { Link, LinkIconPosition } from "@amzn/stencil-react-components/link";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { Text, TextVariant } from "@amzn/stencil-react-components/text";
import IconExternalLinkSmall from "@amzn/stencil-react-icons/icons/icon-external-link-small";
import React, { FC } from "react";
import { BorderedCard } from "../../../../common/components/BorderedCard/bordered-card";
import { EmptyState } from "../../../../common/components/EmptyState/empty-state";
import { HARDWARE_TICKET_URL } from "../../../../common/constants/external-links.constants";
import { InternalLink } from "../../../../common/components/InternalLink/internal-link";
import { getString } from "../../../../common/uistringlabels/ui-string-utils";

const STATES_STRINGS = "orderTracking.states";
const STATE_ILLUSTRATION = "catPlaysFolder";

export interface NotFoundLink {
  label: string;
  url: string;
}

export const OrderLoading: FC = () => (
  <Flex flexDirection="row" justifyContent="center" padding="S700" width="100%">
    <Spinner
      size={SpinnerSize.Medium}
      showText
      loadingText={getString(`${STATES_STRINGS}.loading`)}
    />
  </Flex>
);

export const OrderLoadError: FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <EmptyState
    illustration={STATE_ILLUSTRATION}
    isAlert
    heading={getString(`${STATES_STRINGS}.loadError.heading`)}
    description={getString(`${STATES_STRINGS}.loadError.description`)}
    action={
      <Button variant={ButtonVariant.Primary} onClick={onRetry}>
        {getString(`${STATES_STRINGS}.loadError.tryAgain`)}
      </Button>
    }
  />
);

export const OrderNotFound: FC<{ link: NotFoundLink }> = ({ link }) => (
  <EmptyState
    illustration={STATE_ILLUSTRATION}
    isAlert
    heading={getString(`${STATES_STRINGS}.notFound.heading`)}
    description={getString(`${STATES_STRINGS}.notFound.description`)}
    action={<InternalLink to={link.url}>{link.label}</InternalLink>}
  />
);

export const UnknownStatusMessage: FC = () => (
  <BorderedCard borderRadius="200" padding="S400" gridGap="S200">
    <Text variant={TextVariant.BodyMD} color="color.text.primary">
      {getString(`${STATES_STRINGS}.unknownStatus.message`)}
    </Text>
    <View>
      <Link
        href={HARDWARE_TICKET_URL}
        target="_blank"
        icon={<IconExternalLinkSmall title={getString("orderTracking.opensInNewTab")} />}
        iconPosition={LinkIconPosition.Trailing}
      >
        {getString(`${STATES_STRINGS}.unknownStatus.ticketLink`)}
      </Link>
    </View>
  </BorderedCard>
);
